module.exports = __webpack_public_path__ + "img/m-group.372f5e18.png";